import { render, staticRenderFns } from "./notificationsIndex.pug?vue&type=template&id=7356f442&scoped=true&lang=pug&"
import script from "./notificationsIndex.ts?vue&type=script&lang=ts&"
export * from "./notificationsIndex.ts?vue&type=script&lang=ts&"
import style0 from "./notificationsIndex.scss?vue&type=style&index=0&id=7356f442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7356f442",
  null
  
)

export default component.exports